module.exports = __webpack_public_path__ + "static/media/groundwork-logo-charcoal.141c1514.svg";